import get from 'lodash/fp/get';

const BASE = 'app.poiGeofence';

export const isPoiDialogShown = get(`${BASE}.showPoiDialog`);
export const isGeofenceDialogShown = get(`${BASE}.showGeofenceDialog`);
export const getPoiGeofencePosition = get(`${BASE}.position`);
export const getPoiId = get(`${BASE}.poiId`);
export const getGeofenceId = get(`${BASE}.geofenceId`);
